module.exports = __webpack_public_path__ + "static/img/person-sponsor.5220e42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person-sponsor.jpg
// module id = iYGe
// module chunks = 1